import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  href: string;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}
export function Breadcrumbs({
  items
}: BreadcrumbsProps) {
  // Generate BreadcrumbList Schema
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: 'https://shopilots.com'
    }, ...items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 2,
      name: item.label,
      item: `https://shopilots.com${item.href}`
    }))]
  };
  return <>
      {/* Schema Markup */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(breadcrumbSchema)
    }} data-id="element-74" />

      {/* Visual Breadcrumbs */}
      <nav aria-label="Breadcrumb" className="mb-6" data-id="element-75">
        <ol className="flex items-center gap-2 text-sm" data-id="element-76">
          <li data-id="element-77">
            <Link to="/" className="flex items-center gap-1 text-slate-600 hover:text-slate-900 transition-colors" data-id="element-78">
              <Home size={16} data-id="element-79" />
              <span data-id="element-80">Home</span>
            </Link>
          </li>

          {items.map((item, index) => <li key={index} className="flex items-center gap-2" data-id="element-81">
              <ChevronRight size={16} className="text-slate-400" data-id="element-82" />
              {index === items.length - 1 ? <span className="text-slate-900 font-medium" data-id="element-83">{item.label}</span> : <Link to={item.href} className="text-slate-600 hover:text-slate-900 transition-colors" data-id="element-84">
                  {item.label}
                </Link>}
            </li>)}
        </ol>
      </nav>
    </>;
}